import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;

  position: relative;
  margin-top: 68px;

  @media (min-width: 996px) {
    margin-top: 0;
    max-width: 445px;
  }
`;
